import React from 'react';
import { Zap, CheckCircle2, Loader2, XCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { ActivityBlockMessage } from '../types/space';
interface ActivityBlockProps {
  message: ActivityBlockMessage;
  onToggleDetails: (id: string) => void;
}
export function ActivityBlock({
  message,
  onToggleDetails
}: ActivityBlockProps) {
  const isRunning = message.status === 'running';
  const isCompleted = message.status === 'completed';
  const isFailed = message.status === 'failed';
  return <div className="w-full my-4 pl-11 pr-4" data-id="element-21">
      <div className={`
        w-full rounded-lg border overflow-hidden transition-all
        ${isRunning ? 'bg-white border-amber-200 shadow-sm' : ''}
        ${isCompleted ? 'bg-gray-50 border-gray-200' : ''}
        ${isFailed ? 'bg-red-50 border-red-200' : ''}
      `} data-id="element-22">
        {/* Header */}
        <div className="p-4 flex items-center justify-between" data-id="element-23">
          <div className="flex items-center space-x-3" data-id="element-24">
            <div className={`
              p-1.5 rounded-md
              ${isRunning ? 'bg-amber-100 text-amber-600' : ''}
              ${isCompleted ? 'bg-green-100 text-green-600' : ''}
              ${isFailed ? 'bg-red-100 text-red-600' : ''}
            `} data-id="element-25">
              <Zap className="h-4 w-4" data-id="element-26" />
            </div>
            <div data-id="element-27">
              <h4 className="text-sm font-semibold text-gray-900" data-id="element-28">
                {message.title}
              </h4>
              <div className="flex items-center mt-0.5" data-id="element-29">
                {isRunning && <span className="text-xs text-amber-600 font-medium flex items-center" data-id="element-30">
                    <span className="relative flex h-2 w-2 mr-1.5" data-id="element-31">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" data-id="element-32"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500" data-id="element-33"></span>
                    </span>
                    Working...
                  </span>}
                {isCompleted && <span className="text-xs text-green-600 font-medium" data-id="element-34">
                    Completed
                  </span>}
                {isFailed && <span className="text-xs text-red-600 font-medium" data-id="element-35">
                    Failed
                  </span>}
              </div>
            </div>
          </div>

          <button onClick={() => onToggleDetails(message.id)} className="text-gray-400 hover:text-gray-600 p-1" data-id="element-36">
            {message.showDetails ? <ChevronUp className="h-4 w-4" data-id="element-37" /> : <ChevronDown className="h-4 w-4" data-id="element-38" />}
          </button>
        </div>

        {/* Steps / Log */}
        {message.showDetails && <div className="px-4 pb-4 border-t border-gray-100 bg-gray-50/50 pt-3" data-id="element-39">
            <div className="space-y-3" data-id="element-40">
              {message.steps.map((step, idx) => <div key={idx} className="flex items-center text-sm" data-id="element-41">
                  <div className="mr-3 w-5 flex justify-center" data-id="element-42">
                    {step.status === 'completed' && <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-43" />}
                    {step.status === 'running' && <Loader2 className="h-4 w-4 text-amber-500 animate-spin" data-id="element-44" />}
                    {step.status === 'pending' && <div className="h-2 w-2 rounded-full bg-gray-200" data-id="element-45" />}
                    {step.status === 'failed' && <XCircle className="h-4 w-4 text-red-500" data-id="element-46" />}
                  </div>
                  <span className={`
                    ${step.status === 'pending' ? 'text-gray-400' : 'text-gray-700'}
                    ${step.status === 'running' ? 'font-medium' : ''}
                  `} data-id="element-47">
                    {step.label}
                  </span>
                </div>)}
            </div>
          </div>}

        {!message.showDetails && isCompleted && <div className="px-4 pb-3 text-xs text-gray-500 pl-14" data-id="element-48">
            ✓ {message.steps.length} steps completed successfully
          </div>}
      </div>
    </div>;
}